module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge--light-4ee6d09637fa321914b73f29ec9c09f3.svg";